import {UI} from "../../stem-core/src/ui/UIBase";
import {CloseIcon} from "../../core/ui/SVGElements.jsx";
import {registerStyle} from "../../stem-core/src/ui/style/Theme";
import {collapseIframe} from "../widget/misc/WidgetUtils";
import {WidgetCloseButtonStyle} from "../widget/WidgetCloseButton";
import {styleRuleInherit} from "../../stem-core/src/decorators/Style";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../blink-sdk/utils/AnalyticsClient";


class PanelCloseButtonStyle extends WidgetCloseButtonStyle {
    @styleRuleInherit
    closeButton = {
        opacity: 1,
        cursor: "pointer",
        pointerEvents: "initial",
    };
}

@registerStyle(PanelCloseButtonStyle)
export class PanelCloseButton extends CloseIcon {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            color: this.styleSheet.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_COLOR,
            size: this.styleSheet.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_SIZE,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.closeButton);
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => {
            dispatchAnalyticsEvent(AnalyticsEventType.ELEMENT_CLICK);
            collapseIframe();
        });
    }
}
